import { makeActionCreator } from '../../config/store/utils'
import { getAllProviders } from '../../services/search'

export const GET_BUYERS = 'GET_BUYERS'
export const GET_BUYERS_ERROR = 'GET_BUYERS_ERROR'
export const GET_BUYERS_SUCCESS = 'GET_BUYERS_SUCCESS'
export const onGetBuyers = makeActionCreator(GET_BUYERS)
export const onGetBuyersError = makeActionCreator(GET_BUYERS_ERROR, 'payload')
export const onGetBuyersSuccess = makeActionCreator(GET_BUYERS_SUCCESS, 'payload')
export const onGetBuyersThunk = () => async dispatch => {
  dispatch(onGetBuyers())

  try {
    const response = await getAllProviders()

    if (response.status !== 200) {
      return dispatch(onGetBuyersError(response.data.errores))
    }

    const csvStructure = response.data.map(entity => [entity.name, entity.sector, entity.entcode, entity.idSector])

    return dispatch(onGetBuyersSuccess({ buyers: csvStructure }))
  } catch (error) {
    return dispatch(onGetBuyersError(error))
  }
}
